import BaseService from './BaseService';

export default class CompanyService {
  baseService: BaseService;
  ApiBaseService: BaseService;
  
  constructor(orderType: string) {
      this.baseService = new BaseService(orderType);
      this.ApiBaseService = new BaseService('');
    }

  async info (): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get('company/info');
      return response.data.company;
    } catch (error: any) {
      throw error;
    }
  }

  async tags (): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get('company/tags');
      return response.data.tagCategories;
    } catch (error: any) {
      console.error('Erro CompanyService tags:', error);
      throw error;
    }
  }

  async getPage(slug: string): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get(`company/getPage?slug=${slug}`);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  async processForm(payload: any): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post('company/processForm', payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      return response.data;
    } catch (error: any) {
      console.error('Erro processForm:', error);
      throw error;
    }
  }
}